// Extended translations for admin panel and additional UI elements
// This complements the main LanguageContext translations

export const adminTranslations = {
  es: {
    // Admin tabs
    tabs: {
      statistics: 'Estadísticas',
      orders: 'Pedidos',
      products: 'Productos',
      categories: 'Categorías',
      writers: 'Redactores',
      coupons: 'Cupones',
      users: 'Usuarios',
      queries: 'Consultas',
      clientCatalog: 'Catálogo Cliente',
      recharges: 'Recargas',
      expenses: 'Gastos',
      accounting: 'Contabilidad',
      reminders: 'Recordatorios',
      timeTracking: 'Fichaje',
      chatbot: 'Chatbot',
      siteContent: 'Web',
    },
    // Tools section
    tools: {
      verifyUrls: 'Verificar URLs',
      cleanExcel: 'Limpiar Excel',
      import: 'Importar',
      compareFiles: 'Comparar Archivos',
      linkMonitor: 'Monitor de Enlaces',
      ahrefsBatch: 'Ahrefs Batch',
      integrateAhrefs: 'Integrar Ahrefs',
      cleanUrls: 'Limpiar URLs',
      apiToExcel: 'API a Excel',
      catalogApi: 'API Catálogo',
    },
    // Statistics
    stats: {
      totalUsers: 'Total Usuarios',
      administrators: 'Administradores',
      totalProducts: 'Total Productos',
      available: 'Disponibles',
      countries: 'Países',
      categories: 'Categorías',
      refresh: 'Actualizar',
      panel: 'Panel de Administración',
    },
    // Orders
    orders: {
      title: 'Pedidos',
      search: 'Buscar pedidos...',
      filter: 'Filtrar por estado',
      allStatuses: 'Todos los estados',
      client: 'Cliente',
      media: 'Medio',
      status: 'Estado',
      date: 'Fecha',
      amount: 'Importe',
      actions: 'Acciones',
      noOrders: 'No hay pedidos',
      newOrder: 'Nuevo Pedido',
      editOrder: 'Editar Pedido',
      viewDetails: 'Ver Detalles',
      deleteOrder: 'Eliminar Pedido',
      confirmDelete: '¿Estás seguro de que deseas eliminar este pedido?',
      orderCreated: 'Pedido creado correctamente',
      orderUpdated: 'Pedido actualizado correctamente',
      orderDeleted: 'Pedido eliminado correctamente',
      sendNotification: 'Enviar notificación',
    },
    // Order statuses
    statuses: {
      pending: 'Pte. Aceptación',
      contacting: 'Contactando',
      writer: 'Redactor',
      review: 'Revisión',
      textApproved: 'Texto Aprobado',
      modifications: 'Modificaciones',
      medium: 'Medio',
      published: 'Publicada',
      cancelled: 'Cancelada',
      consulting: 'Consultando',
      incident: 'Incidencia',
      scheduled: 'Programado',
      waitingProforma: 'Espera Proforma',
    },
    // Products
    products: {
      title: 'Productos',
      search: 'Buscar productos...',
      newProduct: 'Nuevo Producto',
      editProduct: 'Editar Producto',
      deleteProduct: 'Eliminar Producto',
      domain: 'Dominio',
      price: 'Precio',
      dr: 'DR',
      traffic: 'Tráfico',
      country: 'País',
      category: 'Categoría',
      status: 'Estado',
      actions: 'Acciones',
      active: 'Activo',
      inactive: 'Inactivo',
      confirmDelete: '¿Estás seguro de que deseas eliminar este producto?',
      productCreated: 'Producto creado correctamente',
      productUpdated: 'Producto actualizado correctamente',
      productDeleted: 'Producto eliminado correctamente',
      importProducts: 'Importar Productos',
      exportProducts: 'Exportar Productos',
    },
    // Users
    users: {
      title: 'Usuarios',
      search: 'Buscar por email...',
      allRoles: 'Todos los roles',
      newUser: 'Nuevo Usuario',
      editUser: 'Editar Usuario',
      deleteUser: 'Eliminar Usuario',
      name: 'Nombre',
      email: 'Email',
      role: 'Rol',
      balance: 'Saldo',
      newsletter: 'Newsletter',
      status: 'Estado',
      discount: 'Descuento',
      actions: 'Acciones',
      active: 'Activo',
      inactive: 'Inactivo',
      admin: 'Administrador',
      worker: 'Trabajador',
      client: 'Cliente',
      confirmDelete: '¿Estás seguro de que deseas eliminar este usuario?',
      userCreated: 'Usuario creado correctamente',
      userUpdated: 'Usuario actualizado correctamente',
      userDeleted: 'Usuario eliminado correctamente',
      impersonate: 'Suplantar usuario',
      adjustBalance: 'Ajustar saldo',
      template: 'Plantilla',
      importUsers: 'Importar',
    },
    // Wallet adjustment
    wallet: {
      adjustTitle: 'Ajustar Saldo',
      currentBalance: 'Saldo actual',
      adjustmentType: 'Tipo de ajuste',
      addBalance: 'Añadir saldo',
      subtractBalance: 'Quitar saldo',
      amount: 'Importe (€)',
      reason: 'Motivo (se enviará al cliente por email)',
      reasonPlaceholder: 'Ej: Compensación por retraso en el pedido #123',
      newBalance: 'Nuevo saldo',
      confirm: 'Confirmar y Notificar',
      processing: 'Procesando...',
      cancel: 'Cancelar',
    },
    // Categories
    categories: {
      title: 'Categorías',
      search: 'Buscar categorías...',
      newCategory: 'Nueva Categoría',
      editCategory: 'Editar Categoría',
      deleteCategory: 'Eliminar Categoría',
      name: 'Nombre',
      products: 'Productos',
      actions: 'Acciones',
      confirmDelete: '¿Estás seguro de que deseas eliminar esta categoría?',
      categoryCreated: 'Categoría creada correctamente',
      categoryUpdated: 'Categoría actualizada correctamente',
      categoryDeleted: 'Categoría eliminada correctamente',
      custom: 'Categorías personalizadas',
      system: 'Categorías del sistema',
    },
    // Coupons
    coupons: {
      title: 'Cupones',
      search: 'Buscar cupones...',
      newCoupon: 'Nuevo Cupón',
      editCoupon: 'Editar Cupón',
      deleteCoupon: 'Eliminar Cupón',
      code: 'Código',
      discount: 'Descuento',
      type: 'Tipo',
      percentage: 'Porcentaje',
      fixed: 'Fijo',
      minPurchase: 'Compra mínima',
      uses: 'Usos',
      maxUses: 'Máx. usos',
      unlimited: 'Ilimitado',
      expires: 'Expira',
      noExpiry: 'Sin expiración',
      status: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo',
      actions: 'Acciones',
      confirmDelete: '¿Estás seguro de que deseas eliminar este cupón?',
      couponCreated: 'Cupón creado correctamente',
      couponUpdated: 'Cupón actualizado correctamente',
      couponDeleted: 'Cupón eliminado correctamente',
    },
    // Recharges
    recharges: {
      title: 'Recargas',
      search: 'Buscar recargas...',
      pending: 'Pendientes',
      approved: 'Aprobadas',
      rejected: 'Rechazadas',
      all: 'Todas',
      client: 'Cliente',
      amount: 'Importe',
      paymentMethod: 'Método de pago',
      date: 'Fecha',
      status: 'Estado',
      actions: 'Acciones',
      approve: 'Aprobar',
      reject: 'Rechazar',
      confirmApprove: '¿Aprobar esta recarga?',
      confirmReject: '¿Rechazar esta recarga?',
      rechargeApproved: 'Recarga aprobada correctamente',
      rechargeRejected: 'Recarga rechazada correctamente',
    },
    // Expenses/Invoices
    expenses: {
      title: 'Gastos',
      income: 'Ingresos',
      search: 'Buscar facturas...',
      newInvoice: 'Nueva Factura',
      editInvoice: 'Editar Factura',
      deleteInvoice: 'Eliminar Factura',
      invoiceNumber: 'Nº Factura',
      provider: 'Proveedor',
      client: 'Cliente',
      concept: 'Concepto',
      amount: 'Importe',
      vat: 'IVA',
      total: 'Total',
      date: 'Fecha',
      actions: 'Acciones',
      confirmDelete: '¿Estás seguro de que deseas eliminar esta factura?',
      invoiceCreated: 'Factura creada correctamente',
      invoiceUpdated: 'Factura actualizada correctamente',
      invoiceDeleted: 'Factura eliminada correctamente',
    },
    // Common actions
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      filter: 'Filtrar',
      export: 'Exportar',
      import: 'Importar',
      refresh: 'Actualizar',
      close: 'Cerrar',
      confirm: 'Confirmar',
      yes: 'Sí',
      no: 'No',
      loading: 'Cargando...',
      noResults: 'No se encontraron resultados',
      error: 'Error',
      success: 'Éxito',
      warning: 'Advertencia',
      info: 'Información',
      actions: 'Acciones',
      details: 'Detalles',
      back: 'Volver',
      next: 'Siguiente',
      previous: 'Anterior',
      all: 'Todos',
      none: 'Ninguno',
      select: 'Seleccionar',
      selectAll: 'Seleccionar todo',
      clearAll: 'Limpiar todo',
      download: 'Descargar',
      upload: 'Subir',
      copy: 'Copiar',
      copied: 'Copiado',
      apply: 'Aplicar',
      reset: 'Reiniciar',
    },
    // Messages
    messages: {
      confirmDelete: '¿Estás seguro de que deseas eliminar este elemento?',
      deleteSuccess: 'Elemento eliminado correctamente',
      deleteError: 'Error al eliminar el elemento',
      saveSuccess: 'Cambios guardados correctamente',
      saveError: 'Error al guardar los cambios',
      loadError: 'Error al cargar los datos',
      networkError: 'Error de conexión',
      unauthorized: 'No tienes permisos para realizar esta acción',
      sessionExpired: 'Tu sesión ha expirado',
      required: 'Este campo es obligatorio',
      invalidEmail: 'Email inválido',
      invalidUrl: 'URL inválida',
      invalidNumber: 'Número inválido',
      minLength: 'Mínimo {min} caracteres',
      maxLength: 'Máximo {max} caracteres',
    },
    // Time tracking
    timeTracking: {
      title: 'Control de Tiempo',
      clockIn: 'Fichar entrada',
      clockOut: 'Fichar salida',
      breakStart: 'Iniciar descanso',
      breakEnd: 'Finalizar descanso',
      currentSession: 'Sesión actual',
      todayHours: 'Horas hoy',
      weekHours: 'Horas semana',
      monthHours: 'Horas mes',
      history: 'Historial',
      date: 'Fecha',
      entry: 'Entrada',
      exit: 'Salida',
      totalHours: 'Total horas',
      breaks: 'Descansos',
      notes: 'Notas',
      status: 'Estado',
      working: 'Trabajando',
      onBreak: 'En descanso',
      offline: 'Desconectado',
    },
  },
  en: {
    tabs: {
      statistics: 'Statistics',
      orders: 'Orders',
      products: 'Products',
      categories: 'Categories',
      writers: 'Writers',
      coupons: 'Coupons',
      users: 'Users',
      queries: 'Queries',
      clientCatalog: 'Client Catalog',
      recharges: 'Recharges',
      expenses: 'Expenses',
      accounting: 'Accounting',
      reminders: 'Reminders',
      timeTracking: 'Time Tracking',
      chatbot: 'Chatbot',
      siteContent: 'Website',
    },
    tools: {
      verifyUrls: 'Verify URLs',
      cleanExcel: 'Clean Excel',
      import: 'Import',
      compareFiles: 'Compare Files',
      linkMonitor: 'Link Monitor',
      ahrefsBatch: 'Ahrefs Batch',
      integrateAhrefs: 'Integrate Ahrefs',
      cleanUrls: 'Clean URLs',
      apiToExcel: 'API to Excel',
      catalogApi: 'Catalog API',
    },
    stats: {
      totalUsers: 'Total Users',
      administrators: 'Administrators',
      totalProducts: 'Total Products',
      available: 'Available',
      countries: 'Countries',
      categories: 'Categories',
      refresh: 'Refresh',
      panel: 'Admin Panel',
    },
    orders: {
      title: 'Orders',
      search: 'Search orders...',
      filter: 'Filter by status',
      allStatuses: 'All statuses',
      client: 'Client',
      media: 'Media',
      status: 'Status',
      date: 'Date',
      amount: 'Amount',
      actions: 'Actions',
      noOrders: 'No orders',
      newOrder: 'New Order',
      editOrder: 'Edit Order',
      viewDetails: 'View Details',
      deleteOrder: 'Delete Order',
      confirmDelete: 'Are you sure you want to delete this order?',
      orderCreated: 'Order created successfully',
      orderUpdated: 'Order updated successfully',
      orderDeleted: 'Order deleted successfully',
      sendNotification: 'Send notification',
    },
    statuses: {
      pending: 'Pending',
      contacting: 'Contacting',
      writer: 'Writer',
      review: 'Review',
      textApproved: 'Text Approved',
      modifications: 'Modifications',
      medium: 'Medium',
      published: 'Published',
      cancelled: 'Cancelled',
      consulting: 'Consulting',
      incident: 'Incident',
      scheduled: 'Scheduled',
      waitingProforma: 'Waiting Proforma',
    },
    products: {
      title: 'Products',
      search: 'Search products...',
      newProduct: 'New Product',
      editProduct: 'Edit Product',
      deleteProduct: 'Delete Product',
      domain: 'Domain',
      price: 'Price',
      dr: 'DR',
      traffic: 'Traffic',
      country: 'Country',
      category: 'Category',
      status: 'Status',
      actions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      confirmDelete: 'Are you sure you want to delete this product?',
      productCreated: 'Product created successfully',
      productUpdated: 'Product updated successfully',
      productDeleted: 'Product deleted successfully',
      importProducts: 'Import Products',
      exportProducts: 'Export Products',
    },
    users: {
      title: 'Users',
      search: 'Search by email...',
      allRoles: 'All roles',
      newUser: 'New User',
      editUser: 'Edit User',
      deleteUser: 'Delete User',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      balance: 'Balance',
      newsletter: 'Newsletter',
      status: 'Status',
      discount: 'Discount',
      actions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      admin: 'Administrator',
      worker: 'Worker',
      client: 'Client',
      confirmDelete: 'Are you sure you want to delete this user?',
      userCreated: 'User created successfully',
      userUpdated: 'User updated successfully',
      userDeleted: 'User deleted successfully',
      impersonate: 'Impersonate user',
      adjustBalance: 'Adjust balance',
      template: 'Template',
      importUsers: 'Import',
    },
    wallet: {
      adjustTitle: 'Adjust Balance',
      currentBalance: 'Current balance',
      adjustmentType: 'Adjustment type',
      addBalance: 'Add balance',
      subtractBalance: 'Subtract balance',
      amount: 'Amount (€)',
      reason: 'Reason (will be sent to customer by email)',
      reasonPlaceholder: 'E.g.: Compensation for delay in order #123',
      newBalance: 'New balance',
      confirm: 'Confirm & Notify',
      processing: 'Processing...',
      cancel: 'Cancel',
    },
    categories: {
      title: 'Categories',
      search: 'Search categories...',
      newCategory: 'New Category',
      editCategory: 'Edit Category',
      deleteCategory: 'Delete Category',
      name: 'Name',
      products: 'Products',
      actions: 'Actions',
      confirmDelete: 'Are you sure you want to delete this category?',
      categoryCreated: 'Category created successfully',
      categoryUpdated: 'Category updated successfully',
      categoryDeleted: 'Category deleted successfully',
      custom: 'Custom categories',
      system: 'System categories',
    },
    coupons: {
      title: 'Coupons',
      search: 'Search coupons...',
      newCoupon: 'New Coupon',
      editCoupon: 'Edit Coupon',
      deleteCoupon: 'Delete Coupon',
      code: 'Code',
      discount: 'Discount',
      type: 'Type',
      percentage: 'Percentage',
      fixed: 'Fixed',
      minPurchase: 'Min. purchase',
      uses: 'Uses',
      maxUses: 'Max. uses',
      unlimited: 'Unlimited',
      expires: 'Expires',
      noExpiry: 'No expiry',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      actions: 'Actions',
      confirmDelete: 'Are you sure you want to delete this coupon?',
      couponCreated: 'Coupon created successfully',
      couponUpdated: 'Coupon updated successfully',
      couponDeleted: 'Coupon deleted successfully',
    },
    recharges: {
      title: 'Recharges',
      search: 'Search recharges...',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      all: 'All',
      client: 'Client',
      amount: 'Amount',
      paymentMethod: 'Payment method',
      date: 'Date',
      status: 'Status',
      actions: 'Actions',
      approve: 'Approve',
      reject: 'Reject',
      confirmApprove: 'Approve this recharge?',
      confirmReject: 'Reject this recharge?',
      rechargeApproved: 'Recharge approved successfully',
      rechargeRejected: 'Recharge rejected successfully',
    },
    expenses: {
      title: 'Expenses',
      income: 'Income',
      search: 'Search invoices...',
      newInvoice: 'New Invoice',
      editInvoice: 'Edit Invoice',
      deleteInvoice: 'Delete Invoice',
      invoiceNumber: 'Invoice #',
      provider: 'Provider',
      client: 'Client',
      concept: 'Concept',
      amount: 'Amount',
      vat: 'VAT',
      total: 'Total',
      date: 'Date',
      actions: 'Actions',
      confirmDelete: 'Are you sure you want to delete this invoice?',
      invoiceCreated: 'Invoice created successfully',
      invoiceUpdated: 'Invoice updated successfully',
      invoiceDeleted: 'Invoice deleted successfully',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      refresh: 'Refresh',
      close: 'Close',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      loading: 'Loading...',
      noResults: 'No results found',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      info: 'Information',
      actions: 'Actions',
      details: 'Details',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      all: 'All',
      none: 'None',
      select: 'Select',
      selectAll: 'Select all',
      clearAll: 'Clear all',
      download: 'Download',
      upload: 'Upload',
      copy: 'Copy',
      copied: 'Copied',
      apply: 'Apply',
      reset: 'Reset',
    },
    messages: {
      confirmDelete: 'Are you sure you want to delete this item?',
      deleteSuccess: 'Item deleted successfully',
      deleteError: 'Error deleting item',
      saveSuccess: 'Changes saved successfully',
      saveError: 'Error saving changes',
      loadError: 'Error loading data',
      networkError: 'Connection error',
      unauthorized: 'You do not have permission to perform this action',
      sessionExpired: 'Your session has expired',
      required: 'This field is required',
      invalidEmail: 'Invalid email',
      invalidUrl: 'Invalid URL',
      invalidNumber: 'Invalid number',
      minLength: 'Minimum {min} characters',
      maxLength: 'Maximum {max} characters',
    },
    timeTracking: {
      title: 'Time Tracking',
      clockIn: 'Clock in',
      clockOut: 'Clock out',
      breakStart: 'Start break',
      breakEnd: 'End break',
      currentSession: 'Current session',
      todayHours: 'Hours today',
      weekHours: 'Hours this week',
      monthHours: 'Hours this month',
      history: 'History',
      date: 'Date',
      entry: 'Entry',
      exit: 'Exit',
      totalHours: 'Total hours',
      breaks: 'Breaks',
      notes: 'Notes',
      status: 'Status',
      working: 'Working',
      onBreak: 'On break',
      offline: 'Offline',
    },
  },
};

// Helper function to get admin translation
export const getAdminText = (key, language = 'es') => {
  const keys = key.split('.');
  let value = adminTranslations[language] || adminTranslations.es;
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

// Export for direct use
export default adminTranslations;
